<template>
  <div>
    Adding navbar sample here
    <center><JsonContact /></center>
  </div>

</template>

<script>

import JsonContact from '../components/JsonContact.vue'

export default {
  name: 'Home',
  components: {JsonContact}

}
</script>
